import { render, staticRenderFns } from "./InplayList.vue?vue&type=template&id=2d3e195c&scoped=true"
import script from "./InplayList.vue?vue&type=script&lang=js"
export * from "./InplayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e195c",
  null
  
)

export default component.exports